import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ErrorsService } from "src/app/services/common/errors.service";
import {
  MatTableDataSource,
  MatSelect,
  MatDialog
} from "@angular/material";

import { ICourse } from "src/app/interfaces/course";
import { IBranch } from "src/app/interfaces/branch";
import { TranslateService } from "@ngstack/translate";
import { ICompany } from "src/app/interfaces/company";
import { ICalendar } from "src/app/interfaces/calendar";
import { ITermInfo } from "src/app/interfaces/term-info";
import { ICourseType } from "src/app/interfaces/course-type";
import { BIDService } from "src/app/services/common/bid.service";
import { CIDService } from "src/app/services/common/cid.service";
import { ICoursePattern } from "src/app/interfaces/coursePattern";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { IGetFullTimeSession } from "src/app/interfaces/get-fullTime-session";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { CourseService } from "src/app/services/http/business/course/course.service";
import { RoomService } from "./../../../../services/http/business/room/room.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { SettingService } from "src/app/services/http/business/setting/setting.service";
import { CalendarService } from "src/app/services/http/business/calendar/calendar.service";
//import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
import { CourseTypeService } from "src/app/services/http/business/course-type/course-type.service";
import { CoursePatternService } from "src/app/services/http/business/course-pattern/course-pattern.service";
import * as momentJalali from "jalali-moment";
//import * as moment from 'moment';
import { ActivatedRoute } from "@angular/router";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IParentTerm } from "src/app/interfaces/parent-term";
import { ParrentTermService } from "src/app/services/http/business/parrent-term/parrent-term-service.service";
import { CourseSelectionComponent } from "./course-selection/course-selection.component";
import { TeacherSelectionComponent } from "src/app/components/teacher-selection/teacher-selection.component";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { environment } from "src/environments/environment";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-course-sessions-checkout",
  templateUrl: "./course-sessions-checkout.component.html",
  styleUrls: ["./course-sessions-checkout.component.css"]
})
export class CourseSessionsCheckoutComponent implements OnInit {
  times = [];
  param: any;
  errorList: IError[] = [];
  convertTZ: any;
  fullTime: any;
  formData: any;
  roomList: any;
  errObject: any;
  isOwner: boolean;
  TermInfoId: number;
  branchList: IBranch;
  yearList: ICalendar;
  errors = new Array();
  companyList: ICompany;
  expand: boolean = true;
  scheduleForm: FormGroup;
  termInfoForm: FormGroup;
  sessionForm: FormGroup;
  sessionDuration: number;
  timeLineEndPoint: number;
  data: IGetFullTimeSession;
  hideTerms: boolean = true;
  timeLineStartPoint: number;
  addCourseEntryData: ICourse;
  courseTypeList: ICourseType;
  hideScheduleTime: boolean = true;
  coursePatternList: ICoursePattern;
  skip: number = 0;
  selectAll: boolean;
  termList: ITermInfo[];
  sessionList = [];
  allSession = [];
  parrentTermList: IParentTerm[];

  currentModel: any;
  //checkAll: boolean;

  route_companyEncryptId: any;
  route_branchEncryptId: any;
  route_termInfoId: any;

  CompanyEncrypt: string;
  BranchEncrypt: string;
  TermInfo: number;

  dataSource = new MatTableDataSource<ITermInfo>();

  //@ViewChild(MatPaginator) paginator: MatPaginator;

  //displayedColumns: string[] = [
  //  "function",
  //  this.translate.get("label.termNumber"),
  //  this.translate.get("label.termName"),
  //  this.translate.get("label.termStartTime"),
  //  this.translate.get("label.termEndTime")
  //];
  form: FormGroup;
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private bidService: BIDService,
    private cidService: CIDService,
    private roomService: RoomService,
    private snackBar: SnackBarService,
    private dialog: MatDialog,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private courseService: CourseService,
    private holdingService: HoldingService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private settingService: SettingService,
    private calendarService: CalendarService,
    //private termService: TermInfoService,
    // private termInfoService: TermInfoService,
    private courseTypeService: CourseTypeService,
    private parrentTermService: ParrentTermService,
    private coursePatternService: CoursePatternService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.createForm();
    this.createSessionForm();
    this.getCompanyList();

    this.route.params.subscribe(res => {
      this.CompanyEncrypt = res.company.replace(/-/g, '=');
      this.BranchEncrypt = res.branch.replace(/-/g, '=');
      this.TermInfo = res.terminfo;
      //this.form.value.CompanyEncryptId = res.company.replace(/-/g, '=');
      this.termList = [];
      this.sessionList = [];
      this.allSession = [];
      this.times = [];
      this.cidService.setCID(this.CompanyEncrypt);
      this.timeLine();
      this.branchService.list(true).subscribe(response => {
        this.branchList = response.DataList;
        if (this.isOwner)
          this.bidService.setBID(this.BranchEncrypt);
        this.getRoomsList();
      });
      // this.termService.list(0, 0).subscribe(response => {
      //   this.termList = response.DataList;
      // });
      //this.form.value.BranchEncryptId = res.branch.replace(/-/g, '=');

      //this.form.value.TermInfoId = res.terminfo;
    });
  }
  // @ViewChild(CourseSessionsCheckoutComponent, {static: true}) Component;
  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (!res.IsOwner) {
        this.timeLine();
        this.getParrentTermList();
        this.form.controls['CompanyEncryptId'].patchValue(this.cidService.getCID());
        this.form.controls['BranchEncryptId'].patchValue(this.bidService.getBID());
      }

    });
  }
  createForm() {
    this.form = this.fb.group({
      CompanyEncryptId: [null, Validators.required],
      BranchEncryptId: [null, Validators.required],
      //TermInfoId: [null, Validators.required],
      ParentTermId: [null, Validators.required],
      DateNow: [new Date(), Validators.required]
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    if (this.isOwner)
      this.cidService.setCID(e.value);
    this.timeLine();
    this.loadBranchList();
    this.loadCoursTypeList();
    this.loadCoursePattern();
    this.getParrentTermList();
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
    this.getRoomsList();
  }

  getParrentTermList() {
    this.parrentTermService.list(0, 0).subscribe(
      res => {
        this.parrentTermList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  createSessionForm() {
    this.sessionForm = this.fb.group({
      sessions: this.fb.array([])
    });
  }

  loadBranchList() {
    this.branchService.list(true).subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadCoursTypeList() {
    this.courseTypeService.list().subscribe(
      res => {
        this.courseTypeList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadYear() {
    this.calendarService.yearList().subscribe(
      res => {
        this.yearList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  nextDay() {
    let date: Date = new Date(this.form.controls["DateNow"].value);
    date.setDate(date.getDate() + 1);
    this.form.controls["DateNow"].setValue(date);
    this.submit(this.form.value);
  }

  previousDay() {
    let date: Date = new Date(this.form.controls["DateNow"].value);
    date.setDate(date.getDate() - 1);
    this.form.controls["DateNow"].setValue(date);
    this.submit(this.form.value);
  }

  validatorSessionDate(termId: any, date: any): boolean {
    let temp = true;
    this.termList.forEach(element => {
      if (element.Id == termId) {
        if (date >= element.StartDate && date <= element.EndDate) {
          temp = true;
        } else {
          temp = false;
        }
      }
    });
    return temp;

  }
  courceSelect(item: any, time: any) {

    let date = momentJalali
      .from(this.form.controls["DateNow"].value, "en").utc(true)
      .format(environment.dateFormat);
    // .toJSON();
    this.form.controls["DateNow"].setValue(date);

    let qoury: any = {
      RoomId: item.Id,
      StartTime: time,
      FromNow: false,
      RoomFormat: true,
      //TermInfo: this.form.controls["TermInfoId"].value,
      //Company: this.form.controls["CompanyEncryptId"].value,
      ParentTerm: this.form.controls["ParentTermId"].value,
      SessionDate: this.form.controls["DateNow"].value,
      CoursePatternId: null,
      Branch: this.form.controls["BranchEncryptId"].value
    }

    //if (this.validatorSessionDate(qoury.TermInfo, qoury.SessionDate)) {
    // this.companyList.forEach(element => {
    //   if (element.CompanyEncryptId == qoury.Company)
    //     qoury.Company = {
    //       Id: element.CompanyEncryptId,
    //       Name: element.CompanyName
    //     }
    // });
    if (this.isOwner)
      this.branchList.forEach(element => {
        if (element.BranchEncryptId == qoury.Branch)
          qoury.Branch = {
            Id: element.BranchEncryptId,
            Name: element.Name
          }
      });
    else {
      qoury.Branch = {
        Id: qoury.Branch,
        Name: this.bidService.getBName()
      }
    }

    this.parrentTermList.forEach(element => {
      if (element.Id == qoury.ParentTerm)
        qoury.ParentTerm = {
          Id: element.Id,
          Title: element.Title,
        }
    });

    this.dialog.open(CourseSelectionComponent, {
      data: qoury,
      width: "800px",
      disableClose: true
    })
      .afterClosed()
      .subscribe(() => {
        this.submit(this.form.value);
      });
    // }
    // else {
    //   this.snackBar.OpenSnackBar(
    //     this.translate.get("error.termDate"),
    //     "ok",
    //     5000,
    //     SoundEnum.beep
    //   );
    // }

  }

  //  new teacher sub
  teacherSelection(room: any, time: string, teacher: any): void {

    let dateNow = this.form.controls["DateNow"].value;
    if (typeof (dateNow) !== 'string')
      dateNow = momentJalali
        .from(dateNow, "en")
        .utc(true)
        .format(environment.dateFormat);

    let command: any = {
      SessionId: teacher.AllSessionId,
      RoomId: room.Id,
      TeacherUserEncryptId: teacher.IsSub ? teacher.SubTeacherUserEncryptId : teacher.TeacherUserEncryptId,
      FullName: teacher.FullName,
      IsMakeUp: teacher.IsMakeUp,
      IsSub: teacher.IsSub,
      StartTime: time,
      SessionDate: dateNow,
    };
    this.dialog.open(TeacherSelectionComponent, {
      data: command,
      disableClose: true
    })
      .afterClosed()
      .subscribe((res) => {

        if (res) {
          command["TeacherUserEncryptId"] = res.TeacherUserEncryptId;
          this.subSave(command);
        }
      });
  }


  // call service subSave
  subSave(item: any): void {

    let command: any = {
      BranchEncryptId: this.form.controls["BranchEncryptId"].value,
      SessionId: item.SessionId,
      TeacherUserEncryptId: item.TeacherUserEncryptId,
    };
    this.courseService.SubSave(command).subscribe(
      () => {

        this.snackBar.OpenSnackBar(
          this.translate.get("success.subTeacher"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.submit(this.form.value);
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  loadCoursePattern() {

    this.coursePatternService.getList().subscribe(
      res => {
        this.coursePatternList = res.DataList;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  calculateDuration(e: MatSelect) {
    this.coursePatternService.getById(e.value).subscribe(res => {
      this.sessionDuration = res.SessionDuration;
    });
  }

  getRoomsList() {
    this.roomService.list(0, 0).subscribe(
      res => {
        this.roomList = res.DataList;
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  checkFullTime(time: Date, _index, room, session): any {
    var res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test) {
        test.RoomTimeList.forEach(element => {
          if (time >= element.TimeStart && time < element.TimeEnd) {
            this.skip = this.calcWidth(element.TimeStart, element.TimeEnd);
            res = true;
            session.teacher = element;
            // this.arry.push(element);
            return res;
          }
        });
      }
    }
    if (this.skip > 0) {
      this.skip = this.skip - 1;
    }

    return res;
  }

  checkStartTime(time, _index, room): any {
    var res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test) {
        test.RoomTimeList.forEach(element => {
          if (time == element.TimeStart) {
            res = true;
            return res;
          }
        });
      }
    }
    return res;
  }

  test(time, _index, room): any {
    let res = false;
    if (this.fullTime && room) {
      var test = this.fullTime.filter(r => r.RoomId == room.Id)[0];
      if (test) {
        test.RoomTimeList.forEach(element => {
          if (time >= element.TimeStart && time <= element.TimeEnd) {
            res = true;
            return;
          }
        });
      }
    }
    return res;
  }

  loadBranchAndTerms(e: any) {

    this.termList = [];
    this.sessionList = [];
    this.allSession = [];
    this.times = [];
    this.cidService.setCID(e.value);
    this.timeLine();
    this.branchService.list(true).subscribe(res => {
      this.branchList = res.DataList;
    });
    // this.termService.list(0, 0).subscribe(res => {
    //   this.termList = res.DataList;
    // });
    this.getParrentTermList();
  }

  submit(data: any) {

    this.hideScheduleTime = true;
    if (typeof (data.DateNow) !== 'string') {
      data.DateNow = momentJalali
        .from(data.DateNow, "en")
        .utc(true)
        .format(environment.dateFormat);
      // data.DateNow=data.DateNow.slice(0,16);

    }
    this.currentModel = {
      TermInfoId: data.TermInfoId,
      BranchEncryptId: data.BranchEncryptId,
      DateNow: data.DateNow
    }
    this.courseService
      .getAttendance(data.ParentTermId, data.BranchEncryptId, data.DateNow)
      .subscribe(res => {

        this.fullTime = res;
        this.fullTime.forEach(element => {
          element.RoomTimeList.forEach(item => {
            if (item.AllSessionStatusId == 91) {
              item["isSelectItem"] = true;
            } else if (item.AllSessionStatusId == 92) {
              item["isSelectItem"] = false;
            } else {
              item["isSelectItem"] = null;
            }
            this.allSession.push(item);
          });
        });
        if (this.allSession.length != 0) {
          this.selectAll = null;
        }

        this.getRoomsList();
        this.hideScheduleTime = false;
      });
    this.sessionList = [];
    this.allSession = [];


  }

  submitSessions() {

    var data = {
      AttendanceStatus: [],
      ParentTermId: this.form.controls['ParentTermId'].value,
      BranchEncryptId: this.currentModel.BranchEncryptId,
      DateNow: this.currentModel.DateNow
    };
    this.sessionList.forEach(element => {
      data.AttendanceStatus.push(element);
    });

    this.courseService.saveAttendance(data).subscribe(() => {

      this.snackBar.OpenSnackBar(
        this.translate.get("success.attendance"),
        "ok",
        5000,
        SoundEnum.beep
      );
      this.submit(data);
    },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      });
  }

  timeLine() {
    this.settingService.getTimeLine().subscribe(
      res => {
        this.timeLineStartPoint = parseInt(res.CourseTimeStart.slice(0, 5));
        this.timeLineEndPoint = parseInt(res.CourseTimeEnd.slice(0, 5));
        var quarterHours = ["00:00", "15:00", "30:00", "45:00"];
        for (var i = this.timeLineStartPoint; i < this.timeLineEndPoint; i++) {
          for (let j = 0; j < 4; j++) {
            if (i < 10) {
              this.times.push("0" + i + ":" + quarterHours[j]);
            } else {
              this.times.push(i + ":" + quarterHours[j]);
            }
          }
        }
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  check(allSessionStatusId: number) {
    switch (allSessionStatusId) {
      case 91:
        return true;
      case 92:
        return false;
      default:
        return null;
    }
  }

  operationSelectAll(statusId: number, eventChecked: boolean) {

    console.log(this.fullTime);
    this.sessionList = [];
    this.fullTime.forEach(item => {
      item.RoomTimeList.forEach(element => {

        element["isSelectItem"] = eventChecked;
        this.sessionList.push({
          AllSessionId: element.AllSessionId,
          StatusId: statusId,
          IsMakeUp: element.IsMakeUp
        });
        this.check(statusId);
      });
    });

    console.log(this.sessionList);
  }

  checkAllSessions() {

    if (this.selectAll)
      this.operationSelectAll(91, true);

    else
      this.operationSelectAll(92, false);

  }

  checkList(event, teacher) {

    if (this.selectAll != null) {
      this.selectAll = false;
    }

    if (this.sessionList == null) {
      this.sessionList = [];
    }

    if (this.sessionList.map(function (e) { return e.AllSessionId; }).indexOf(teacher.AllSessionId) < 0) {

      if (event.checked) {
        this.sessionList.push({
          AllSessionId: teacher.AllSessionId,
          StatusId: 91,
          IsMakeUp: teacher.IsMakeUp
        });
        teacher.isSelectItem = true;
      }
      else {
        this.sessionList.push({
          AllSessionId: teacher.AllSessionId,
          StatusId: 92,
          IsMakeUp: teacher.IsMakeUp
        });
        teacher.isSelectItem = false;
      }
    }
    else {
      if (event.checked) {
        this.sessionList[this.sessionList.map(function (e) { return e.AllSessionId; }).indexOf(teacher.AllSessionId)].StatusId = 91,
          teacher.IsMakeUp = teacher.IsMakeUp, teacher.isSelectItem = true;
      }
      else {
        this.sessionList[this.sessionList.map(function (e) { return e.AllSessionId; }).indexOf(teacher.AllSessionId)].StatusId = 92,
          teacher.IsMakeUp = teacher.IsMakeUp, teacher.isSelectItem = false;
      }
    }
  }

  calcWidth(timeStart, timeEnd) {
    var timeS = Number(timeStart.split(':')[0]) * 60 * 60 * 1000 + Number(timeStart.split(':')[1]) * 60 * 1000;
    var timeE = Number(timeEnd.split(':')[0]) * 60 * 60 * 1000 + Number(timeEnd.split(':')[1]) * 60 * 1000;
    return Math.ceil(((timeE - timeS) / (1000 * 60 * 15)));
  }

  courseSessionsCheckout() {
    //this.router.navigate(["/management/institute/courseSessionsCheckout"]);
  }

  //delete sub teacher
  subDelete(room: any, time: string, teacher: any) {

    console.log(room);
    console.log(time);
    console.log(teacher);

    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.isSub")
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog.open(ConfirmComponent, {
      width: "300px",
      data: confirm
    })
      .afterClosed()
      .subscribe(
        res => {

          if (res) {
            this.courseService.subDelete({ Id: teacher.AllSessionId }).subscribe(() => {

              this.snackBar.OpenSnackBar(
                this.translate.get("success.deleteSub"),
                "ok",
                5000,
                SoundEnum.beep
              );
              this.submit(this.form.value);
            }, err => {
              // this.errObject = this.errorService.getError(err);
              // this.param = this.errorService.objectError(this.errObject);
              // this.errors = this.errorService.returnError(err);
              this.errorList = this.errorService.getErrorList(err.error);
            });
          }
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );

  }

  //delete makeup
  makeUpDelete(room: any, time: string, teacher: any) {

    console.log(room);
    console.log(time);
    console.log(teacher);

    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.makeup")
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog.open(ConfirmComponent, {
      width: "300px",
      data: confirm
    })
      .afterClosed()
      .subscribe(
        res => {

          if (res) {
            this.courseService.makeUpDelete({ Id: teacher.AllSessionId }).subscribe(() => {

              this.snackBar.OpenSnackBar(
                this.translate.get("success.deleteMakeUp"),
                "ok",
                5000,
                SoundEnum.beep
              );
              this.submit(this.form.value);
            }, () => {
              this.snackBar.OpenSnackBar(
                this.translate.get("error.deleteMakeUp"),
                "ok",
                5000,
                SoundEnum.beep
              );

            });
          }
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
  }

}
